










import { Vue, Component } from 'vue-property-decorator';
import PreparacionEquipos from '@/pantallas/Conecta/PreparacionEquipos/PreparacionEquipos.vue';

@Component({
  components: { PreparacionEquipos },
})
export default class PreparacionEquiposPantalla extends Vue {}
